var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cast",
      style: _vm.$store.getters["customizer/getCastStyles"]
    },
    [
      _c(
        "div",
        {
          staticClass: "cast__header",
          style: _vm.$store.getters["customizer/getCastHeaderStyles"]
        },
        [
          _c(
            "div",
            {
              staticClass: "cast__back",
              class: { "cast__back--active": _vm.backFocused }
            },
            [
              _c("span", { staticClass: "cast__back-icon" }, [_vm._v("←")]),
              _vm._v(" " + _vm._s(_vm.getBack) + "\n    ")
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cast__title" }, [
            _vm._v(_vm._s(_vm.getTitle))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cast__spacer" })
        ]
      ),
      _vm._v(" "),
      _vm.step === "tiles"
        ? _c("div", { staticClass: "cast__tiles" }, [
            _c("div", { staticClass: "cast__grid" }, [
              _c(
                "div",
                {
                  staticClass: "cast__arrow",
                  class: { "cast__arrow--hidden": !_vm.canScrollLeft }
                },
                [_vm._v("‹")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cast__viewport", style: _vm.viewportStyle },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cast__track",
                      class: { "cast__track--centered": !_vm.scrollable },
                      style: _vm.trackStyle
                    },
                    _vm._l(_vm.apps, function(app, index) {
                      return _c(
                        "div",
                        {
                          key: app.key,
                          staticClass: "cast__tile",
                          class: {
                            "cast__tile--active": index === _vm.selectedIndex
                          },
                          style: _vm.tileStyle(app, index === _vm.selectedIndex)
                        },
                        [
                          app.logo && !_vm.logoFailed[app.key]
                            ? _c("img", {
                                staticClass: "cast__tile-logo",
                                attrs: { src: app.logo, alt: app.name },
                                on: {
                                  error: function($event) {
                                    return _vm.onLogoError(app)
                                  }
                                }
                              })
                            : _c("div", { staticClass: "cast__tile-name" }, [
                                _vm._v(_vm._s(app.name))
                              ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cast__arrow",
                  class: { "cast__arrow--hidden": !_vm.canScrollRight }
                },
                [_vm._v("›")]
              ),
              _vm._v(" "),
              _vm.apps.length === 0
                ? _c("div", { staticClass: "cast__empty" }, [
                    _vm._v(_vm._s(_vm.getNoApps))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cast__footer" }, [
              _c("div", { staticClass: "cast__footer-hint" }, [
                _vm._v(_vm._s(_vm.getCastTilesHint))
              ]),
              _vm._v(" "),
              _vm.canLaunchCastEntry
                ? _c("div", { staticClass: "cast__footer-hint" }, [
                    _vm._v(_vm._s(_vm.getCastEntryHint))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasGuestData
                ? _c("div", { staticClass: "cast__footer-hint" }, [
                    _vm._v(_vm._s(_vm.getClearHint))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "cast__footer-hint" }, [
                _vm._v(_vm._s(_vm.getTilesBackHint))
              ])
            ])
          ])
        : _vm.step === "launch"
        ? _c("div", { staticClass: "cast__pairing" }, [
            _c("div", { staticClass: "cast__pairing-row" }, [
              _c(
                "div",
                { staticClass: "cast__pairing-info" },
                [
                  _c("div", { staticClass: "cast__pairing-app" }, [
                    _vm._v(_vm._s(_vm.launchAppName))
                  ]),
                  _vm._v(" "),
                  _vm.launchState === "failed"
                    ? [
                        _c("div", { staticClass: "cast__pairing-text" }, [
                          _vm._v(_vm._s(_vm.launchFailText))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cast__pairing-text" }, [
                          _vm._v(_vm._s(_vm.getUnavailableHint))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cast__pairing-hint" }, [
                          _vm._v(_vm._s(_vm.getUnavailableKeys))
                        ]),
                        _vm._v(" "),
                        _vm.launchError
                          ? _c("div", { staticClass: "cast__launch-detail" }, [
                              _vm._v(_vm._s(_vm.launchError))
                            ])
                          : _vm._e()
                      ]
                    : [
                        _c("div", { staticClass: "cast__pairing-status" }, [
                          _c("span", { staticClass: "cast__pairing-dot" }),
                          _vm._v(_vm._s(_vm.launchStatus) + "\n          ")
                        ]),
                        _vm._v(" "),
                        _vm.launchState === "installing"
                          ? _c("div", { staticClass: "cast__pairing-hint" }, [
                              _vm._v(_vm._s(_vm.getInstallWait))
                            ])
                          : _vm._e()
                      ]
                ],
                2
              )
            ])
          ])
        : _c("div", { staticClass: "cast__pairing" }, [
            _c("div", { staticClass: "cast__pairing-row" }, [
              _c("div", { staticClass: "cast__pairing-info" }, [
                _c("div", { staticClass: "cast__pairing-app" }, [
                  _vm._v(_vm._s(_vm.getConnectTitle))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cast__pairing-text" }, [
                  _vm._v(_vm._s(_vm.getPairingText))
                ]),
                _vm._v(" "),
                _vm.qrSvg && _vm.softAP.ssid
                  ? _c("div", { staticClass: "cast__pairing-access" }, [
                      _c("div", { staticClass: "cast__pairing-ssid" }, [
                        _vm._v(_vm._s(_vm.getWifiLabel) + ": "),
                        _c("strong", [_vm._v(_vm._s(_vm.softAP.ssid))])
                      ]),
                      _vm._v(" "),
                      _vm.softAP.key
                        ? _c("div", { staticClass: "cast__pairing-ssid" }, [
                            _vm._v(
                              "\n            " + _vm._s(_vm.getPwLabel) + ": "
                            ),
                            _c("strong", [_vm._v(_vm._s(_vm.softAP.key))])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.pairing.watching
                  ? _c(
                      "div",
                      {
                        staticClass: "cast__pairing-status",
                        class: {
                          "cast__pairing-status--ok": _vm.pairing.connected
                        }
                      },
                      [
                        _c("span", { staticClass: "cast__pairing-dot" }),
                        _vm._v(_vm._s(_vm.getPairingStatus) + "\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.autoForward > 0
                  ? _c("div", { staticClass: "cast__pairing-hint" }, [
                      _vm._v(_vm._s(_vm.getStayHint))
                    ])
                  : !_vm.preparing && !_vm.hotspotDown
                  ? _c("div", { staticClass: "cast__pairing-hint" }, [
                      _vm._v(_vm._s(_vm.getContinueHint))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.canLaunchCastEntry
                  ? _c("div", { staticClass: "cast__pairing-hint" }, [
                      _vm._v(_vm._s(_vm.getCastEntryHint))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasGuestData
                  ? _c("div", { staticClass: "cast__pairing-hint" }, [
                      _vm._v(_vm._s(_vm.getClearHint))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.qrSvg
                ? _c("div", {
                    staticClass: "cast__qr",
                    domProps: { innerHTML: _vm._s(_vm.qrSvg) }
                  })
                : _vm.preparing || _vm.hotspotDown
                ? _c("div", { staticClass: "cast__qr cast__qr--wait" }, [
                    _c("span", { staticClass: "cast__qr-dot" }),
                    _vm._v(" "),
                    _vm.hotspotTries > 0
                      ? _c("span", { staticClass: "cast__qr-tries" }, [
                          _vm._v(_vm._s(_vm.hotspotTries))
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _vm.dialog
        ? _c("div", { staticClass: "cast__dialog" }, [
            _c("div", { staticClass: "cast__dialog-box" }, [
              _c("div", { staticClass: "cast__dialog-title" }, [
                _vm._v(_vm._s(_vm.getClearTitle))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cast__dialog-text" }, [
                _vm._v(_vm._s(_vm.dialogText))
              ]),
              _vm._v(" "),
              _vm.dialogButtons.length
                ? _c(
                    "div",
                    { staticClass: "cast__dialog-buttons" },
                    _vm._l(_vm.dialogButtons, function(button, index) {
                      return _c(
                        "div",
                        {
                          key: button.action,
                          staticClass: "cast__dialog-button",
                          class: {
                            "cast__dialog-button--active":
                              index === _vm.dialogIndex
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(button.label) + "\n        "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79a44263", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a44263","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cast.vue
// module id = null
// module chunks = 